import Box from '../Box/index'
import styles from './BillingDetails.module.scss'

const goodColor = '#32BE39'
const badColor = '#FF5E5E'

const BillingDetails = ({
  invoiceReconcileInDays,
  invoicePayInDays,
  isAutoPayEnabled,
  handleOpenEditDialog
}) => (
  <div className={styles.wrapper}>
    <Box title="Billing details">
      <div className={styles.container}>
        <button className={styles.editButton} onClick={handleOpenEditDialog}>
          Edit
        </button>
        <div className={styles.row}>
          <div className={styles.rowName}>Reconciliation period</div>
          <div className={styles.rowValue}>{invoiceReconcileInDays} days</div>
        </div>
        <div className={styles.row}>
          <div className={styles.rowName}>Payment period</div>
          <div className={styles.rowValue}>{invoicePayInDays} days</div>
        </div>
        <div className={styles.row}>
          <div className={styles.rowName}>Auto payments</div>
          <div className={styles.rowValue}>
            <span style={{ color: isAutoPayEnabled ? goodColor : badColor }}>
              {isAutoPayEnabled ? 'Enabled' : 'Disabled'}
            </span>
          </div>
        </div>
      </div>
    </Box>
  </div>
)

export default BillingDetails
